import { ProductType } from '@tink/core/src/types';

export enum AnalyticsProduct {
  PAY = 'PAY',
  UNKNOWN = 'UNKNOWN',
  REPORTS = 'REPORTS',
  AUTHORIZE = 'AUTHORIZE',
  CREDENTIALS = 'CREDENTIALS',
  INCOME_CHECK = 'INCOME_CHECK',
  TRANSACTIONS = 'TRANSACTIONS',
  ACCOUNT_CHECK = 'ACCOUNT_CHECK',
  RISK_INSIGHTS = 'RISK_INSIGHTS',
  BUSINESS_TRANSACTIONS = 'BUSINESS_TRANSACTIONS',
  BUSINESS_ACCOUNT_CHECK = 'BUSINESS_ACCOUNT_CHECK',
  EXPENSE_CHECK = 'EXPENSE_CHECK',
  PRODUCTS = 'PRODUCTS',
  INVESTMENTS = 'INVESTMENTS',
  LOANS = 'LOANS',
}

const analyticsProductMap: Record<ProductType, AnalyticsProduct> = {
  [ProductType.PAY]: AnalyticsProduct.PAY,
  [ProductType.REPORTS]: AnalyticsProduct.REPORTS,
  [ProductType.AUTHORIZE]: AnalyticsProduct.AUTHORIZE,
  [ProductType.CREDENTIALS]: AnalyticsProduct.CREDENTIALS,
  [ProductType.INCOME_CHECK]: AnalyticsProduct.INCOME_CHECK,
  [ProductType.TRANSACTIONS]: AnalyticsProduct.TRANSACTIONS,
  [ProductType.ACCOUNT_CHECK]: AnalyticsProduct.ACCOUNT_CHECK,
  [ProductType.RISK_INSIGHTS]: AnalyticsProduct.RISK_INSIGHTS,
  [ProductType.BUSINESS_TRANSACTIONS]: AnalyticsProduct.BUSINESS_TRANSACTIONS,
  [ProductType.BUSINESS_ACCOUNT_CHECK]: AnalyticsProduct.BUSINESS_ACCOUNT_CHECK,
  [ProductType.EXPENSE_CHECK]: AnalyticsProduct.EXPENSE_CHECK,
  [ProductType.PRODUCTS]: AnalyticsProduct.PRODUCTS,
  [ProductType.ANY]: AnalyticsProduct.UNKNOWN,
};

export const getAnalyticsProduct = (product: ProductType): AnalyticsProduct => {
  return analyticsProductMap[product];
};
